if (!customElements.get('gms-refined-reviews')) customElements.define('gms-refined-reviews', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.rows = [...this.querySelectorAll('[data-review-row]')];
    this.list = this.querySelector('[data-review-list]');
    this.filter = 'all';
    this.page = 1;
    this.pageSize = 6;
    this.querySelector('[data-review-tools]').hidden = false;
    this.querySelector('[data-review-pagination]').hidden = false;
    this.querySelectorAll('[data-review-filter]').forEach(button => button.addEventListener('click', () => {
      this.filter = button.dataset.reviewFilter;
      this.querySelectorAll('[data-review-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      this.page = 1;
      this.render();
    }, options));
    this.querySelector('[data-review-sort]').addEventListener('change', () => { this.page = 1; this.render(); }, options);
    this.querySelector('[data-review-prev]').addEventListener('click', () => { this.page--; this.render(true); }, options);
    this.querySelector('[data-review-next]').addEventListener('click', () => { this.page++; this.render(true); }, options);
    this.querySelectorAll('[data-review-gallery-shift]').forEach(button => button.addEventListener('click', () => {
      this.querySelector('[data-review-gallery]').scrollBy({ left: Number(button.dataset.reviewGalleryShift) * 380, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, options));
    this.querySelector('.gms-review-write').addEventListener('click', event => {
      const button = this.querySelector('#judgeme_product_reviews [data-testid="write-review-button"], #judgeme_product_reviews .jdgm-write-rev-link');
      if (button) { event.preventDefault(); button.click(); }
    }, options);
    this.render();
  }
  render(scroll = false) {
    let rows = this.rows.filter(row => this.filter !== 'photos' || row.dataset.photos === 'true');
    const sort = this.querySelector('[data-review-sort]').value;
    rows.sort((a, b) => sort === 'oldest' ? a.dataset.date.localeCompare(b.dataset.date) : sort === 'highest' ? Number(b.dataset.rating) - Number(a.dataset.rating) || b.dataset.date.localeCompare(a.dataset.date) : sort === 'lowest' ? Number(a.dataset.rating) - Number(b.dataset.rating) || b.dataset.date.localeCompare(a.dataset.date) : b.dataset.date.localeCompare(a.dataset.date));
    this.rows.forEach(row => { row.hidden = true; });
    const pages = Math.max(1, Math.ceil(rows.length / this.pageSize));
    this.page = Math.max(1, Math.min(this.page, pages));
    rows.forEach((row, i) => { this.list.append(row); row.hidden = i < (this.page - 1) * this.pageSize || i >= this.page * this.pageSize; });
    this.querySelector('[data-review-count-label]').textContent = this.dataset.countLabel.replace('[count]', rows.length);
    this.querySelector('[data-review-page-label]').textContent = this.dataset.pageLabel.replace('[page]', this.page).replace('[pages]', pages);
    this.querySelector('[data-review-prev]').disabled = this.page === 1;
    this.querySelector('[data-review-next]').disabled = this.page === pages;
    if (scroll) { this.querySelector('[data-review-tools]').scrollIntoView({ block: 'start', behavior: 'instant' }); this.querySelector('[data-review-page-label]').focus({ preventScroll: true }); }
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
});
